export default "__VITE_ASSET__f616be14__"